import { ConnectButton } from "@rainbow-me/rainbowkit";

export function WalletButton() {
	return (
		<ConnectButton.Custom>
			{({ account, chain, openAccountModal, openChainModal, openConnectModal, mounted }) => {
				const ready = mounted;
				const connected = ready && account && chain;

				return (
					<div
						className="wallet-btn-root"
						{...(!ready && {
							"aria-hidden": true,
							style: { opacity: 0, pointerEvents: "none", userSelect: "none" },
						})}
					>
						{(() => {
							if (!connected) {
								return (
									<button className="wallet-btn wallet-btn--connect" onClick={openConnectModal} type="button">
										<span className="wallet-btn__dot" />
										Connect
									</button>
								);
							}

							if (chain.unsupported) {
								return (
									<button className="wallet-btn wallet-btn--wrong-chain" onClick={openChainModal} type="button">
										Wrong network
									</button>
								);
							}

							return (
								<div className="wallet-btn-group">
									<button className="wallet-btn wallet-btn--chain" onClick={openChainModal} type="button">
										{chain.hasIcon && chain.iconUrl && (
											<img
												className="wallet-btn__chain-icon"
												alt={chain.name ?? "Chain"}
												src={chain.iconUrl}
											/>
										)}
									</button>
									<button className="wallet-btn wallet-btn--account" onClick={openAccountModal} type="button">
										{account.displayBalance && (
											<span className="wallet-btn__balance">{account.displayBalance}</span>
										)}
										<span className="wallet-btn__address">{account.displayName}</span>
									</button>
								</div>
							);
						})()}
					</div>
				);
			}}
		</ConnectButton.Custom>
	);
}
